import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

import { getFormatDate } from '../utils/resolved-format-date';

@Pipe({
	name: 'copoDate',
})
export class DatePipe implements PipeTransform {
	transform(value: Date | moment.Moment | string | undefined, format: string) {
		if (!value) {
			return value;
		}

		return moment(value).format(getFormatDate(format));
	}
}
